import { createDuck } from "redux-duck"
import valueEqual from "value-equal"

import setNestedValue from "lib/nested-values/setNestedValue"
import getNestedValue from "lib/nested-values/getNestedValue"

export { default as withMutation } from "./withMutation"
export { default as provideMutation } from "./provideMutation"

export const STORE_KEY = "mutation"

const duck = createDuck("mutation", "lactastic")

export const SET = duck.defineType("SET")
export const RESET = duck.defineType("RESET")
export const DELETE = duck.defineType("DELETE")
export const SUBMIT_START = duck.defineType("SUBMIT_START")
export const SUBMIT_FINISH = duck.defineType("SUBMIT_FINISH")
export const SUBMIT_ERROR = duck.defineType("SUBMIT_ERROR")
export const VALIDATION_ERROR = duck.defineType("VALIDATION_ERROR")
export const CLEAR_VALIDATION_ERROR = duck.defineType("CLEAR_VALIDATION_ERROR")
export const RESET_VALIDATION_ERROR = duck.defineType("RESET_VALIDATION_ERROR")

export const setValue = duck.createAction(SET)
export const reset = duck.createAction(RESET)
export const deleteElement = duck.createAction(DELETE)

export const submitStart = duck.createAction(SUBMIT_START)
export const submitFinish = duck.createAction(SUBMIT_FINISH)
export const submitError = duck.createAction(SUBMIT_ERROR)

export const validationError = duck.createAction(VALIDATION_ERROR)
export const clearValidationError = duck.createAction(CLEAR_VALIDATION_ERROR)
export const resetValidationErrors = duck.createAction(RESET_VALIDATION_ERROR)

const initialState = {}

export default duck.createReducer(
  {
    [SET]: (state, action) => {
      const { payload } = action
      const basePath = payload.path.slice(0, payload.path.lenth - 1)
      const field = payload.path[payload.path.length - 1]

      state = setNestedValue(
        [payload.mutationKey, "changes", ...payload.path],
        state,
        payload.value
      )
      const error = getNestedValue([payload.mutationKey, "error"], state)
      if (error && error.graphQLErrors) {
        const graphQLError = error.graphQLErrors.find(e => e.validationErrors)

        if (graphQLError) {
          const filtered = graphQLError.validationErrors.filter(
            e => e.field != field && !valueEqual(e.path, basePath)
          )

          if (filtered.length !== graphQLError.validationErrors.lenth) {
            const index = error.graphQLErrors.indexOf(graphQLError)

            if (filtered.length === 0) {
              if (error.graphQLErrors.length === 1) {
                state = setNestedValue([payload.mutationKey, "error"], state, undefined)
              } else {
                state = setNestedValue(
                  [payload.mutationKey, "error", "graphQLErrors", index],
                  state,
                  undefined
                )
              }
            } else {
              state = setNestedValue(
                [payload.mutationKey, "error", "graphQLErrors", index, "validationErrors"],
                state,
                filtered
              )
            }
          }
        }
      }

      const clientErrors = getNestedValue([payload.mutationKey, "clientErrors"], state)
      if (clientErrors && clientErrors.length > 0) {
        const filtered = clientErrors.filter(e => e.field != field && !valueEqual(e.path, basePath))

        if (filtered.length !== clientErrors.length) {
          if (filtered.length === 0) {
            state = setNestedValue([payload.mutationKey, "clientErrors"], state, undefined)
          } else {
            state = setNestedValue([payload.mutationKey, "clientErrors"], state, filtered)
          }
        }
      }

      return state
    },

    [RESET]: (state, action) => {
      const { payload } = action
      const path = [payload.mutationKey]

      return setNestedValue(path, state, undefined)
    },

    [SUBMIT_START]: (state, action) => {
      const { payload } = action

      state = setNestedValue([payload.mutationKey, "submittedAt"], state, payload.timestamp)
      state = setNestedValue([payload.mutationKey, "submitFinishedAt"], state, undefined)

      return state
    },

    [SUBMIT_FINISH]: (state, action) => {
      const { payload } = action

      state = setNestedValue([payload.mutationKey, "submitFinishedAt"], state, payload.timestamp)
      state = setNestedValue([payload.mutationKey, "error"], state, undefined)
      state = setNestedValue([payload.mutationKey, "changes"], state, undefined)

      return state
    },

    [SUBMIT_ERROR]: (state, action) => {
      const { payload } = action

      state = setNestedValue([payload.mutationKey, "submitFinishedAt"], state, payload.timestamp)
      state = setNestedValue([payload.mutationKey, "error"], state, payload.error)

      return state
    },

    [VALIDATION_ERROR]: (state, action) => {
      const { payload: { mutationKey, ...validationError } } = action
      const path = [mutationKey, "clientErrors"]
      const clientErrors = getNestedValue(path, state, [])

      if (clientErrors.find(e => valueEqual(e, validationError))) {
        return state
      }

      return setNestedValue([...path, "-"], state, validationError)
    },

    [CLEAR_VALIDATION_ERROR]: (state, action) => {
      const { payload: { mutationKey, field, path: fieldPath } } = action
      const path = [mutationKey, "clientErrors"]
      const clientErrors = getNestedValue(path, state)

      if (!clientErrors) {
        return state
      }

      const filteredErrors = clientErrors.filter(
        e => e.field != field || !valueEqual(e.path, fieldPath)
      )

      if (filteredErrors.length === 0) {
        return setNestedValue(path, state, undefined)
      } else {
        return setNestedValue(path, state, filteredErrors)
      }
    },

    [RESET_VALIDATION_ERROR]: (state, action) => {
      const { payload: { mutationKey } } = action
      const path = [mutationKey, "clientErrors"]

      return setNestedValue(path, state, undefined)
    },
  },
  initialState
)



// WEBPACK FOOTER //
// ../ui-kit/src/lib/store/Mutation/Store.js